import React, { useEffect, useState } from "react";
import styles from "./ActivityCard.module.scss";
import tirthan from "../../../assets/new-images/destination-5.jpg";
import { animateScroll as scroll } from "react-scroll";

import imgNotFound from "../../../assets/images/single-image.png";
import { formatIndianCurrency } from "../../../utils/utils";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ActivityCard from "./ActivityCard";
import Skeleton from "react-loading-skeleton";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";

const ActivityCardSection = ({ heading }) => {
  const [showSendEnquiryPopup, setShowSendEnquiryPopup] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const itemsPerPage = 9;
  const [bookingData, setBookingData] = useState({});
  const [loader, setLoader] = useState(true);
  const location = useLocation();
  const [children, setChildren] = useState(0);
  const [childAge, setChildAge] = useState([]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const childAges = [];
    let i = 1;
    while (params.has(`childAge[${i}]`)) {
      childAges.push(params.get(`childAge[${i}]`));
      i++;
    }

    const data = {
      location: params.get("location"),
      room: params.get("room"),
      adult: params.get("adult"),
      children: params.get("children"),
      radio: params.get("radio"),
      childAge: childAges,
    };
    setBookingData(data);
    fetchActivitiesData(data);
    setChildren(data.children);
    setChildAge(childAges);
  }, [location.search]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const clearSelection = () => {
    // console.log("Clearing selection...");
  };

  // Calculate start and end index of items to display
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const [packageData, setPackageData] = useState([]);
  // console.log(packageData, "packageData");

  const fetchActivitiesData = async (data) => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    // myHeaders.append("key", 'hlK4o2AHNpJLiXNW9BISzovvLKOCcPp77WfGVjhkhv6hwk8Hja3');
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);

    const formdata = new FormData();
    // formdata.append("location", data.location);
    // formdata.append("limit", 8);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/activities/fetch`,
        requestOptions
      );
      const result = await response.json();
      setLoader(false);

      // const filteredData = result?.data?.filter(
      //   (item) => item.canBookable === 1
      // );
      setPackageData(result?.data);
    } catch (error) {
      setPackageData([]);
      setLoader(false);
      console.error(error);
    }
  };

  // console.log(packageData)

  const [markupData, setMarkupData] = useState(null);

  const fetchMarkup = async () => {
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/markups`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          const findObject = result?.data?.find(
            (mark) => mark?.markupCustomer === "both"
          );
          setMarkupData(findObject || null);
        } else {
          setMarkupData("No data found");
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    fetchActivitiesData();
    fetchMarkup();
  }, []);

  const [selectedActivity, setSelectedActivity] = useState(null);

  return (
    <div className="container">
      {" "}
      {/* <h4 className="new_ui_heading">Top Selling Activites</h4> */}
      <div className={styles.heading_div}>
        <h3 className="new_ui_heading">
          Popular Activities in Himachal Pradesh
        </h3>
        <Link to={"/all-activities"} className={styles.view_all_btn}>
          View All
        </Link>
      </div>

      <div className='desktop_card_sec'>
        {loader ? (
          <div className={styles.activity_flex_card_sec}>
            {Array.from({ length: 6 }).map((items, index) => (
              <div
                key={index}
                className={styles.activity_card}
                style={{
                  background: "none",
                  marginBottom: "0px",
                  boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                  padding: "0px",
                }}
              >
                <div>
                  <Skeleton height={250} />
                </div>
                <div className="card_content" style={{ marginTop: "0px" }}>
                  <h6>
                    <Skeleton width="60%" />
                  </h6>
                  <h6>
                    <Skeleton width="40%" />
                  </h6>
                
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className={`${styles.activity_flex_card_sec} m_0`}>
            {" "}
            {packageData?.slice(0, 6)?.map((data, index) => (
              <ActivityCard
                key={index}
                imgSrc={data.featuredImage ? data.featuredImage : imgNotFound}
                title={data.activityName}
                activityDestination={data.activityDestination}
                activityName={data.activityName}
                price={data.startingPrice}
                bookingLink={data.bookingLink}
                detailsLink={data.detailsLink}
                packagehandle={data.packagehandle}
                canBookable={data?.canBookable}
                description={data?.activityDescription}
                id={data?.activityId}
                slug={data?.activityHandle}
                setShowSendEnquiryPopup={setShowSendEnquiryPopup}
                markupData={markupData}
                sendEnquiry={() => {
                  setSelectedActivity(data);
                  setShowSendEnquiryPopup(true);
                }}
              />
            ))}
          </div>
        )}
        <div className="newui_view_all_btn_mobile_div">
          <Link to={"/all-activities"} className="newui_view_all_btn_mobile">
            View All
          </Link>
        </div>
      </div>

      <div className='mobile_card_sec'>
        {loader ? (
          <div className={styles.activity_flex_card_sec}>
            <div
              className={styles.activity_card}
              style={{
                background: "none",
                marginBottom: "0px",
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                padding: "0px",
              }}
            >
              <div>
                <Skeleton height={150} />
              </div>
              <div className="card_content" style={{ marginTop: "0px" }}>
                <h6>
                  <Skeleton width="60%" />
                </h6>
                <h6>
                  <Skeleton width="40%" />
                </h6>
                <h6>
                  <Skeleton width="20%" />
                </h6>
                <h6>
                  <Skeleton width="24%" />
                </h6>
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.activity_flex_card_sec}>
            <Swiper
              modules={[Pagination]}
              pagination={{ clickable: true }}
              loop={true}
              slidesPerView={1}
              className="mobile_card_slider"
            >
              {packageData?.slice(0, 6)?.map((data, index) => (
                <SwiperSlide key={index}>
                  <ActivityCard
                    key={index}
                    imgSrc={data.featuredImage ? data.featuredImage : imgNotFound}
                    title={data.activityName}
                    activityDestination={data.activityDestination}
                    activityName={data.activityName}
                    price={data.startingPrice}
                    bookingLink={data.bookingLink}
                    detailsLink={data.detailsLink}
                    packagehandle={data.packagehandle}
                    canBookable={data?.canBookable}
                    description={data?.activityDescription}
                    id={data?.activityId}
                    slug={data?.activityHandle}
                    setShowSendEnquiryPopup={setShowSendEnquiryPopup}
                    markupData={markupData}
                    sendEnquiry={() => {
                      setSelectedActivity(data);
                      setShowSendEnquiryPopup(true);
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
        <div className="newui_view_all_btn_mobile_div">
          <Link to={"/all-activities"} className="newui_view_all_btn_mobile">
            View All
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ActivityCardSection;
